<template>
  <span class="audit-state-text" :style="{ color: stateColor[state] }">{{ stateText }}</span>
</template>
<script>
import { AuditState, AuditStateVal } from "@/utils/enum";
export default {
  name: "audit-state-text",
  props: { state: Number },
  computed: {
    stateText() {
      return AuditState[this.state];
    },
  },
  data() {
    return {
      stateColor: {
        [AuditStateVal.inReview]: "#E6A23C",
        [AuditStateVal.passed]: "#67C23A",
        [AuditStateVal.refuse]: "#F56C6C",
        [AuditStateVal.withdraw]: "#909399",
      },
    };
  },
};
</script>
<style scoped lang="scss">
.audit-state-text {
  font-size: 12px;
}
</style>
